const INVOKED = 'Information Card Generator - Invoked';
const ERROR = 'Information Card Generator - Error';
const CORS_REJECTION = 'Information Card Generator - CORS Rejection';
const FB_TITLE_ERROR = 'Information Card Generator - Fallback Title Error';
const FB_DESCRIPTION_ERROR = 'Information Card Generator - Fallback Description Error';

export const INFORMATION_CARD_GENERATOR = {
  INVOKED,
  ERROR,
  CORS_REJECTION,
  FB_TITLE_ERROR,
  FB_DESCRIPTION_ERROR,
} as const;
